import React from "react";
import "./AboutUsMission.css";
import { Stack } from "react-bootstrap";
import { Image } from "react-bootstrap";

export const AboutUsMission = () => {

    const cardData = [
        {
            title: 'Prioritize Our Partners & Clients',
            img: 'https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/mission1.webp',
            desc: " We believe lasting success begins with strong relationships. Our team of destination experts works closely with global travel partners, ensuring every itinerary, event, or group movement is managed with precision, care, and transparency."
        },
        {
            title: 'Embrace Innovation',
            img: 'https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/mission/mission2.webp',
            desc: "We constantly evolve through collaboration and market insight by curating new travel products, immersive experiences, and efficient digital solutions. This give our partners a competitive edge in an ever-changing industry."
        },
        {
            title: 'Strive for Excellence',
            img: 'https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/mission/mission3.webp',
            desc: "Excellence defines every detail of what we do. From crafting tailor-made itineraries to managing large-scale operations, we maintain global service standards while delivering the authenticity and warmth that make every Blueberry DMC experience memorable."
        },

    ]

    return (
        <>
            <div className="AboutUsMission standard-padding">
            <h1 className="heading" style={{color: 'black' , textAlign: 'center' }}>Mission</h1>
                <Stack className="AboutUsMission-items-mobile-container">

                    {
                        cardData.map((e) => (
                            <div className="AboutUsMission-items-mobile" style={{ border: "none" }}>
                                <Image className="AboutUsMission-items-image" alt="img" src={e.img} />
                                <div className="AboutUsMission-card-body">
                                <p className=" subheading AboutUsMission-items-text"> {e.title}</p>
                                <p className="AboutUsMission-items-text2 ">{e.desc}</p>
                                </div>
                              
                            </div>
                        ))
                    }

                </Stack>
            </div>
        </>
    )
}